import "./DeviceManage.css"
import "../GlobalStyles.css"
import {useTranslation} from "react-i18next";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import React, {useEffect, useState} from "react";
import {useLoading} from "../../context/LoadingContext";
import {useAuth} from "../../context/AuthContext";
import AccountsService from "../../services/AccountsService";
import Loader from "../Loader/Loader";
import {useNavigate} from "react-router-dom";
import GenericError from "../Utilities/GenericError";
import PopUp from "../Utilities/PopUp";

export default function DeviceManage() {
    const navigate = useNavigate();
    const {t} = useTranslation();

    const {loggedIn} = useAuth();
    const {isLoading, removeLoading, addLoading} = useLoading();

    const [devices, setDevices] = useState([])
    const fetchDevices = () => {
        return AccountsService.getDevices()
            .then(response => {
                if(!response.data.deviceList){
                    throw new Error();
                }
                setDevices(response.data.deviceList ?? [])
            })
            .catch(error => {
                setGenericError(true)
                setErrorMessage("retrieveError")
            })
    }
    useEffect(() => {
        if(!(isLoading("INIT"))){
            addLoading("INIT")
        }
        if (loggedIn) {
            fetchDevices()
                .finally(()=>{
                    removeLoading("INIT")
                })
        }
    }, [loggedIn]); //eslint-disable-line react-hooks/exhaustive-deps

    const [genericError, setGenericError] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);

    const handleLogout = (deviceId)=>{
        addLoading("LOGOUT_DEVICE")
        AccountsService.logoutDevice({deviceId: deviceId})
            .then(response => {
                return fetchDevices();
            })
            .catch(e =>{
                setGenericError(true)
                setErrorMessage("logoutError")
            })
            .finally(()=>{
                removeLoading("LOGOUT_DEVICE")
            })
    }

    const iconFinder = (type)=>{
        switch (type){
            case "Mobile":
                return {src:"images/devices/mobile.svg", alt:"Mobile device"};
            case "Tablet":
                return {src:"images/devices/mobile.svg", alt:"Mobile device"};
            case "Tv":
                return {src:"images/devices/tv.svg", alt:"Tv device"};
            case "Web":
                return {src:"images/devices/desktop.svg", alt: "Web device"};
            default:
                return {src:"images/devices/desktop.svg", alt: "Other device"};
        }
    }
    return (<>
        {isLoading()?
            <Loader />:
            <>
                <div className={"device-management-container"}>
                    <div className={"device-management-wrapper"}>
                        <div className={"device-management-header"}>
                            <button
                                className="blue"
                                id="goBackButton"
                                onClick={()=>{navigate("/Account")}}
                            >
                                <ArrowBackIcon />
                                {t("goBackButton")}
                            </button>
                            <h1>{t("deviceManagementTitle")}</h1>
                        </div>
                        <p>{t("deviceManagementDescription")}</p>
                        <div className={"device-management-content"}>
                            <div className={"device-management-content-header"}>
                                <h2>{t("deviceManagementHeader")}{(` (${devices?.length})`)}</h2>
                            </div>
                            <div className={"device-management-devices"}>
                                {devices?.map((item, index) => (
                                    <div key={index} className={"device-management-device"}>
                                        <div>
                                            <img className={""} alt={"to-be-re-written"} {...iconFinder(item.type)}/>
                                            <span>{item.name}</span>
                                        </div>
                                        <button
                                            onClick={handleLogout.bind(null, item.deviceId)}>{t("deviceManagementCTA")}</button>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                <PopUp
                    openPopUp={genericError}
                    setOpenPopUp={setGenericError}
                    maxWidth="md"
                    showCloseButton={true}
                    outlined={false}
                    error={true}
                    closeWhenClickedOutside={false}>
                    <GenericError
                        setClose={setGenericError}
                        buttonText={t("deviceManagementErrorCTA")}
                        executeFunction={function () {
                            navigate('/Account');
                        }}
                        mainText={t("deviceManagementErrorTitle")}
                        showIcon={false}>
                <span className={"pick-program-fallback-modal"}>
                    {t("deviceManagementErrorMsg."+errorMessage)}
                </span>
                    </GenericError>
                </PopUp>
            </>
        }
    </>)
}